import { Validator } from '@vista-digital/validator';
import type { EmblaOptionsType } from 'embla-carousel';

/**
 * Configuration options for the carousel, the properties extend the "EmblaOptionsType" type provided by the `embla-carousel` package.
 */
export type CarouselSettings = Pick<
    EmblaOptionsType,
    'slidesToScroll' | 'watchDrag' | 'dragFree' | 'loop' | 'duration' | 'breakpoints' | 'align'
>;

export type CarouselSettingsBreakpoints = Pick<CarouselSettings, 'breakpoints'>;

export type CarouselNumberOrAuto = number | 'auto';

export enum Alignment {
    Start = 'start',
    Center = 'center'
}

export const carouselNumberOrAutoValidator = Validator.any([
    Validator.number(),
    Validator.isEqualTo<CarouselNumberOrAuto>('auto')
]);

export const carouselSettingsValidator = Validator.object<CarouselSettings>({
    slidesToScroll: carouselNumberOrAutoValidator,
    watchDrag: Validator.optional(Validator.boolean()),
    dragFree: Validator.optional(Validator.boolean()),
    loop: Validator.optional(Validator.boolean()),
    duration: Validator.optional(Validator.number({ min: 20, max: 60 })),
    breakpoints: Validator.optional(Validator.object<CarouselSettingsBreakpoints>({})),
    align: Validator.optional(Validator.oneOf<Alignment>(Object.values(Alignment)))
});
